'use client';

import clsx from 'clsx';

interface LogoTileProps {
  idx: number;
  selectedTileIdx: number;
  handleSelectStory: (idx: number) => void;
  children: React.ReactNode;
}

const LogoTile = ({ idx, selectedTileIdx, handleSelectStory, children }: LogoTileProps) => {
  return (
    <button
      className={clsx(
        `group relative flex flex-1 cursor-pointer items-center justify-center p-4 py-4 pt-10 transition-all before:absolute before:left-0 before:top-0 before:h-[3px] before:bg-gradle-blue before:transition-[width] before:duration-[800]`,
        selectedTileIdx == idx ? `before:w-full` : 'before:w-0',
      )}
      onClick={() => handleSelectStory(idx)}
    >
      {children}
    </button>
  );
};

export default LogoTile;
